import { PARTNER_INVENTORY_VIEW_MODES } from "./partnerInventoryDefaultView.js";

const STORAGE_PREFIX = "automap:partner:inventoryViewPreference:";

function isBrowser() {
  return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
}

export function getPartnerInventoryViewPreference(dealerId) {
  if (!isBrowser() || !dealerId) return null;
  try {
    const value = window.localStorage.getItem(`${STORAGE_PREFIX}${dealerId}`);
    if (
      value === PARTNER_INVENTORY_VIEW_MODES.FLAT ||
      value === PARTNER_INVENTORY_VIEW_MODES.GROUPED
    ) {
      return value;
    }
    return null;
  } catch {
    return null;
  }
}

export function setPartnerInventoryViewPreference(dealerId, viewMode) {
  if (!isBrowser() || !dealerId) return;
  try {
    if (
      viewMode === PARTNER_INVENTORY_VIEW_MODES.FLAT ||
      viewMode === PARTNER_INVENTORY_VIEW_MODES.GROUPED
    ) {
      window.localStorage.setItem(`${STORAGE_PREFIX}${dealerId}`, viewMode);
    }
  } catch {
    // Ignore storage failures.
  }
}
